<template>
  <div class="wt2-radio-box-component" :class="{ '-disabled': disabled }">
    <label v-if="labelLeft" v-once :for="guid" class="-label-left">{{
      labelLeft
    }}</label>
    <input
      type="radio"
      v-once
      :id="guid"
      :name="group"
      :checked="selected"
      :disabled="disabled"
      @change="onSelect($event)"
      ref="input"
    />
    <label v-once :for="guid" class="-body"></label>
    <label v-if="labelRight" v-once :for="guid" class="-label-right">{{
      labelRight
    }}</label>
  </div>
</template>

<script>
import app from 'app';

export default {
  props: {
    // radio group name
    group: {
      type: String,
      required: true,
    },
    // value representing selected radio
    value: {
      type: [String, Number, Boolean],
      required: false,
    },
    // selection state of current radio
    selected: {
      type: Boolean,
      required: false,
      default: false,
    },
    labelLeft: {
      type: String,
      required: false,
      default: '',
    },
    labelRight: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      guid: app.guid(),
    };
  },

  methods: {
    onSelect() {
      this.$emit('select', this.value);
    },
  },

  watch: {
    selected(isSelected) {
      this.$refs.input.checked = !!isSelected;
    },
  },
};
</script>
